import script from "./RequestView.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestView.vue?vue&type=script&setup=true&lang=js"

import "./RequestView.vue?vue&type=style&index=0&id=86d7b7c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d7b7c0"]])

export default __exports__